/**
 * Ordre de composition « nom de famille / prénom » d'une personne physique.
 * Miroir de `core.enums.PersonNameOrderEnum` côté back (#1087, #1088).
 */
export enum PersonNameOrderEnum {
    FirstLast = 'first_last',
    LastFirst = 'last_first',
}
